import { requester } from "App";
import { useEffect, useState } from "react";
import style from "./AutoOrdering.module.css";
import Container from "layouts/container/Container";
import Center from "layouts/wrapper/Center";
import P from "components/P";

function AutoOrdering() {
    const [isMounted, setMounted] = useState(false);
    const [activeTab, setActiveTab] = useState('success');
    const [products, setProducts] = useState([]);
    const [orderRequests, setOrderRequests] = useState([]);


    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        requester.getAutoOrderingList((result) => {
            // 데이터 처리 로직, 예제 데이터를 기반으로 가정
            if (result.code === 0) {
                const successData = result.data.filter(item => item.failureType === "SUCCESS");
                const failureData = result.data.filter(item => item.failureType === "InventoryShortage");
                
                
                setProducts(successData);
                setOrderRequests(failureData);
            }

        });
    }, [isMounted]);
    const successTable = (data) => (
        <table className={style.table}>
            <thead>
                <tr>
                    <th>No.</th>
                    <th>날짜</th>
                    <th>발주서 Id</th>
                    <th>상태</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.createDateTime}</td>
                            <td>{item.orderRequestsId || 'N/A'}</td>
                            <td>{item.failureType === "SUCCESS" ? '성공' : '기타'}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

    const failureTable = (data) => (
        <table className={style.table}>
            <thead>
                <tr>
                    <th>No.</th>
                    <th>날짜</th>
                    <th>상품 아이디</th>
                    <th>상태</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => {
                    

                    return (
                        <tr key={index}>

                            <td>{index + 1}</td>
                            <td>{item.createDatetime}</td>
                            <td>{item.productId}</td>
                            <td>{item.failureType === "InventoryShortage" ? '본사상품재고부족' : '기타'}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>자동발주내역</P>
                </Center>

                <div className={style.tabs}>
                    <button
                        className={`${style.tabButton} ${activeTab === 'success' && style.active}`}
                        onClick={() => setActiveTab('success')}
                    >
                        자동발주성공
                    </button>
                    <button
                        className={`${style.tabButton} ${activeTab === 'failure' && style.active}`}
                        onClick={() => setActiveTab('failure')}
                    >
                        자동발주실패
                    </button>
                </div>
                <div className={style.tabContent}>
                    {activeTab === 'success' ? successTable(products) : failureTable(orderRequests)}
                </div>
            </Container>
        </Container>
    );
}

export default AutoOrdering;